import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import {
  checkboxOption,
  checkBoxIcon,
  checkBoxIconActive,
} from '../styles.module.css';

const TagSelect = ({ update }) => {
  const {
    filters: {
      tag: { availableTags, tags: preSelectedTags },
    },
  } = useContext(DiscoveryContext);

  const [tags, setTags] = useState(
    availableTags.map((tag) => ({
      ...tag,
      selected: !!preSelectedTags.find((n) => n.slug === tag.slug),
    })),
  );

  const onToggle = (slug) => {
    const selectedTags = tags.map((tag) => {
      const selected = tag.slug === slug ? !tag.selected : tag.selected;
      return { ...tag, selected };
    });

    setTags(selectedTags);
    update({ tags: selectedTags.filter((n) => n.selected).map((n) => n.slug) });
  };

  return (
    <div>
      {tags &&
        tags.map(({ slug, label, selected }) => {
          return (
            <div
              key={slug}
              className={checkboxOption}
              onClick={() => onToggle(slug)}
              onKeyPress={() => onToggle(slug)}
            >
              <span
                className={classnames(checkBoxIcon, {
                  [checkBoxIconActive]: selected,
                })}
              ></span>
              <span>{label}</span>
            </div>
          );
        })}
    </div>
  );
};

export default TagSelect;
